import { useEffect } from 'react';
import { Providers } from './Providers';
import { AppRouter } from './Router';
import { setGlobalProperties } from '@/shared/analytics/openpanel';

export function App() {
  useEffect(() => {
    setGlobalProperties({
      app: 'platform',
      env: import.meta.env.MODE,
    });
  }, []);

  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
